import React, { useEffect, useState } from "react";
import UserProfileInfo from "./UserProfileInfo";
import { getUserProfiles } from "app/services/profileServices/Profile";

const UserProfileSettings = () => {

  const [profiles, setProfiles] = useState<any>()
  const [isLoading, setIsLoading] = useState<boolean>(true)

  const listProfiles = async () => {
    const data = await getUserProfiles();
    setProfiles(data)
    setIsLoading(false)
  }

  useEffect(() => {
    listProfiles()
  }, [])

  return (
    <>
      {!isLoading && (
        <UserProfileInfo profilesData={profiles} listProfiles={listProfiles}/>
      ) }
    </>
  )

}

export default UserProfileSettings